import CustomerInstallationListResourceModel from '../../generated/types/model/resource/CustomerInstallationListResourceModel';

export default class CustomerInstallationListResourceViewModel extends CustomerInstallationListResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
